import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { StorySettingsConstants as ui } from '../../Config/UIConstants';
import { EmptyContentOnTabDisplay } from '../../SharedComponents/EmptyContentOnTabDisplay';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { CollectionGrid } from '../../SharedComponents/GridDisplay/CollectionGrid';
import { ActiveTabState, NavigationContainer } from '../../SharedComponents/MainPageWithNavigator/MainPageWithNavigator';
import { IPhotoWithComments } from '../../Stores/StoryStore';
import { RouteFormats } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';

interface IProps {
    store: ApplicationStore;
}

@inject('store')
@observer
export class StoryDetailPage extends React.Component<IProps & RouteComponentProps<any>> {
    public componentDidMount(): void {
        window.scrollTo(0, 0);
    }

    private renderItem = (object: IPhotoWithComments, index: number) => {
        return (
            <FullContainer style={styles.itemContainer}>
                <img
                    src={object.photo.thumbnail_url || object.photo.url}
                    style={styles.photoContainer}
                    onClick={() => this.props.history.push(`/viewstory/${parseInt(this.props.match.params.id)}/${object.photo.id}`, { cameFromDetail: true })}
                />
            </FullContainer>
        );
    }

    public render() {
        if (this.props.store.storyStore === undefined || this.props.store.storyStore.storiesAreLoaded === false) {
            return <NavigationContainer {...this.props} activeTabState={ActiveTabState.ALBUMS} />;
        }

        const story = this.props.store.storyStore.getStoryByID(parseInt(this.props.match.params.id));
        if (story === undefined) {
            return null;
        }

        if ([...story.photosWithComments].length === 0) {
            return (
                <NavigationContainer
                    {...this.props}
                    activeTabState={ActiveTabState.ALBUMS}
                    title={story.title}
                    secondaryButton={{
                        text: ui.ALBUM_SETTINGS,
                        action: () => this.props.history.push(RouteFormats.storySettings(parseInt(this.props.match.params.id)))
                    }}
                >
                    <FullContainer style={styles.flexCenter}>
                        <EmptyContentOnTabDisplay
                            header={ui.NO_PHOTOS}
                            subHeader={ui.NO_PHOTOS_SUBTEXT}
                            buttonText={ui.ADD_PHOTOS}
                            onPress={() => this.props.history.push(`/addphotostostory/${parseInt(this.props.match.params.id)}`)}
                        />
                    </FullContainer>
                </NavigationContainer>
            );
        }

        return (
            <NavigationContainer
                {...this.props}
                activeTabState={ActiveTabState.STORY_DETAIL}
                primaryButton={{
                    text: ui.ADD_PHOTOS,
                    action: () => this.props.history.push(`/addphotostostory/${parseInt(this.props.match.params.id)}`)
                }}
                secondaryButton={{
                    text: ui.ALBUM_SETTINGS,
                    action: () => this.props.history.push(RouteFormats.storySettings(parseInt(this.props.match.params.id)))
                }}
                title={story.title}
            >
                <FullContainer>
                    <CollectionGrid content={story.photosWithComments} renderItem={this.renderItem} isSquareContent={true} />
                </FullContainer>
            </NavigationContainer>
        );
    }
}

const styles = {
    addPhotosButton: {
        width: 200,
        height: 65
    },
    subText: {
        opacity: 0.5,
        marginBottom: 15
    },
    noPhotosText: {
        fontSize: 28,
        fontWeight: 900,
        textAlign: 'center',
        color: 'black',
        marginBottom: 15
    } as React.CSSProperties,
    flexCenter: {
        display: 'flex',
        justifyContent: 'center'
    } as React.CSSProperties,
    photoContainer: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        objectPosition: 'top'
    } as React.CSSProperties,
    photoCountText: {
        color: 'white',
        marginBottom: 15
    },
    storyTitleText: {
        fontWeight: 900,
        fontSize: 19,
        color: 'white'
    } as React.CSSProperties,
    topTextContainer: {
        height: 70,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingLeft: 20
    } as React.CSSProperties,
    commentCountText: {
        position: 'absolute',
        top: -6,
        right: 17.5,
        color: '#6F6F6F',
        fontSize: 11,
        fontWeight: 900,
        textAlign: 'center',
        width: 20
    } as React.CSSProperties,
    commentBubble: (isPrivate: boolean) => {
        return {
            position: 'absolute',
            top: isPrivate ? -22 : -15,
            right: isPrivate ? -8 : 12,
            bottom: 0,
            height: isPrivate ? 70 : 30,
            width: isPrivate ? 70 : 30,
            fill: 'white',
            objectFit: 'contain'
        } as React.CSSProperties;
    },
    commentContainer: {
        position: 'relative',
        height: 50,
        width: 50
    } as React.CSSProperties,
    storyOwner: {
        color: 'white',
        fontSize: 13,
        paddingLeft: 22,
        marginTop: -10
    },
    textContainer: {
        height: 30,
        width: '100%',
        marginTop: 26,
        display: 'flex',
        justifyContent: 'space-between'
    } as React.CSSProperties,
    cardContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        height: '100%',
        width: '100%',
        backgroundColor: '#00000044',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    } as React.CSSProperties,
    itemContainer: {
        position: 'relative',
        cursor: 'pointer'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/Pages/StoriesPage/StoryDetailPage.tsx